// react
import {
    React,
    useState,
    useEffect,
    Fragment,
    } from 'react';
import { connect } from 'react-redux';
// import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
// third-party
// import AppLink from '../shared/AppLink';
import { getData } from '../../services/fetch-service';
import emailIcon from '../../img/gmail.png';
import pin from '../../img/placeholder.png';
import phoneIcon from '../../img/call.png';
// import PropTypes from 'prop-types';
// application
// import thesari from '../../img/Sliderbox/thesari.png';
// import budget from '../../img/Sliderbox/budget.png';
// import tatimi from '../../img/Sliderbox/tatimi.png';
// import partnership from '../../img/Sliderbox/partnership.png';
// import socialet from '../../img/Sliderbox/socialet.png';
// import puna from '../../img/Sliderbox/puna.png';
// import raportet from '../../img/Sliderbox/raportet.png';

const documentPattern = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|zip|rar)(\?.*)?$/i;
const imagePattern = /\.(png|jpe?g|gif|webp|svg|bmp)(\?.*)?$/i;

function fileUrl(href) {
    if (!href) {
        return '';
    }
    const filesPath = process.env.REACT_APP_FILESPATH || '';
    const match = href.match(/\/desk\/inc\/media\/([^?#]+)/i);
    if (match && filesPath) {
        return `${filesPath}${decodeURIComponent(match[1])}`;
    }
    return href;
}

function splitPageContent(html) {
    if (!html || !String(html).trim() || typeof DOMParser === 'undefined') {
        return { html: '', documents: [], photos: [] };
    }
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const documents = [];
    const photos = [];
    parsed.querySelectorAll('a').forEach((anchor) => {
        const href = anchor.getAttribute('href') || '';
        const name = (anchor.textContent || '').trim() || decodeURIComponent((href.split('/').pop() || '').split('?')[0]);
        if (imagePattern.test(href) && !anchor.querySelector('img')) {
            photos.push({ href: fileUrl(href), name });
            anchor.remove();
            return;
        }
        const isDocument = !imagePattern.test(href) && (/\/desk\/inc\/media\//i.test(href) || documentPattern.test(href));
        if (isDocument) {
            documents.push({ href: fileUrl(href), name });
            anchor.remove();
            return;
        }
        if (href) {
            anchor.setAttribute('href', fileUrl(href));
            if (/^https?:/i.test(anchor.getAttribute('href'))) {
                anchor.setAttribute('target', '_blank');
                anchor.setAttribute('rel', 'noreferrer');
            }
        }
    });
    parsed.querySelectorAll('img').forEach((img) => {
        const src = img.getAttribute('src') || '';
        if (src) {
            img.setAttribute('src', fileUrl(src));
        }
        img.removeAttribute('width');
        img.removeAttribute('height');
    });
    parsed.body.querySelectorAll('p, div, span').forEach((node) => {
        if (!node.querySelector('img, table, video, iframe, ul, ol') && !(node.textContent || '').replace(/\u00a0/g, ' ').trim()) {
            node.remove();
        }
    });
    const text = (parsed.body.textContent || '').replace(/\s+/g, ' ').trim();
    const hasRichContent = parsed.body.querySelector('img, table, video, iframe, ul, ol');
    return {
        html: (text || hasRichContent) ? parsed.body.innerHTML.trim() : '',
        documents,
        photos,
    };
}

function contactCards(list, details) {
    const detailRows = Array.isArray(details) ? details : [];
    const listRows = Array.isArray(list) ? list : [];
    const detailById = new Map(detailRows.filter((item) => item && item.kontaktiId).map((item) => [String(item.kontaktiId), item]));
    const source = listRows.length ? listRows : detailRows;
    return source.map((item, index) => {
        const detail = detailById.get(String(item.kontaktiId)) || {};
        const listed = listRows.length ? item : {};
        return {
            id: item.kontaktiId || `contact-${index}`,
            name: detail.personiKontaktues || listed.personiKontaktues || listed.kontaktiPershkrimi || detail.kontaktiPershkrimi || '',
            phone: detail.telefoni || listed.telefoni || '',
            email: (listed.emaili || detail.emaili || '').trim(),
        };
    }).filter((item) => item.name || item.phone || item.email);
}

function BlockContact(props) {
    const url = window.location.pathname.split('/').pop();
    const params = useParams();
    const {
        locale, isMainContact, contactsList, selectedId, onSelect,
    } = props;
    const [contact, setContact] = useState(null);
    useEffect(() => {
        Promise.all([
            getData(`Contact/GetContacts?PageID=${params.id}&Gjuha=${locale}`).catch(() => null),
            getData(`Page/GetBasicPage?PageID=${params.id}&Gjuha=${locale}`).catch(() => null),
            getData(`Page/GetPageWithDocs?PageID=${params.id}&Gjuha=${locale}&skip=0&take=50`).catch(() => null),
        ]).then(([contactResponse, pageResponse, docsResponse]) => {
            const rows = contactResponse && Array.isArray(contactResponse.data) ? contactResponse.data : [];
            const page = pageResponse && pageResponse.data && pageResponse.data[0];
            if (!rows.length && !page) {
                setContact(null);
                return;
            }
            const content = splitPageContent(page && page.pageText);
            const filesPath = process.env.REACT_APP_FILESPATH || '';
            const attached = ((docsResponse && docsResponse.data && docsResponse.data.mediaLista) || [])
                .map((docs) => {
                    const media = docs.media || {};
                    const href = media.otherSource ? media.otherSource : `${filesPath}${media.mediaEmri || ''}${media.mediaEx || ''}`;
                    const name = (docs.pageMedia && docs.pageMedia.pershkrimi) || media.mediaEmri || '';
                    const isImage = imagePattern.test(media.mediaEx || '') || imagePattern.test(href);
                    return href ? { href, name, isImage } : null;
                })
                .filter((item) => item && (item.name || item.isImage));
            const knownHrefs = new Set(content.documents.map((document) => document.href));
            const knownPhotos = new Set(content.photos.map((photo) => photo.href));
            setContact({
                ...(rows[0] || {}),
                rows,
                pageName: (page && page.pageName) || (rows[0] && rows[0].pageName) || '',
                contentHtml: content.html,
                photos: content.photos.concat(attached.filter((item) => item.isImage && item.href && !knownPhotos.has(item.href))),
                documents: content.documents.concat(attached.filter((item) => !item.isImage && !knownHrefs.has(item.href))),
            });
        });
    }, [url, locale]);
    // const ddlContact = ddlc.map((item, index) => {
    //     const path = process.env.REACT_APP_FILESPATH;
    //     const image = `${path}${item.media[0]?.mediaEmri}${item.media[0]?.mediaEx}`;
    //     return (
    //         <li key={index}>
    //             {item.hasChild === true ? (
    //                 <div className="slider-box-link slider-box-link-childs">
    //                     <img src={image} alt="" />
    //                     <div className="link-childs-list">
    //                         <div className="and-devider">
    //                             <Link to={item.url}>
    //                                 {item.pageName}
    //                             </Link>
    //                             <p><FormattedMessage id="and" defaultMessage="dhe" /></p>
    //                         </div>

    //                         {item.submenu.map((submenu, key) => {
    //                             return (
    //                                 <Link key={key} to={submenu.url}>
    //                                     {submenu.pageName}
    //                                 </Link>
    //                             );
    //                         })}
    //                     </div>

    //                 </div>
    //             )
    //                 : (
    //                     <Link className="slider-box-link" to={item.url}>
    //                         <img src={image} alt="" />
    //                         {item.pageName}
    //                     </Link>
    //                 )}
    //         </li>
    //     );
    // });

    const cards = contactCards(contactsList, contact && contact.rows);
    const multiple = cards.length > 1;

    if (!contact) {
        return null;
    }

    if (isMainContact) {
        return (
            <ul className="slider-boxes-contact slider-boxes-contact--classic">
                <li>
                    <div className="slider-box-link-contact">
                        <img src={pin} alt="" />
                        <h3><FormattedMessage id="Adresa" defaultMessage="Adresa" /></h3>
                        <p>{contact && contact.adresa}</p>
                    </div>
                </li>
                <li>
                    <a href={`tel:${contact && contact.telefoni}`} className="slider-box-link-contact">
                        <img src={phoneIcon} alt="" />
                        <h3><FormattedMessage id="Telefoni" defaultMessage="Telefoni" /></h3>
                        <p>{contact && contact.telefoni}</p>
                    </a>
                </li>
                <li>
                    <a href={`mailto:${contact && contact.emaili}`} className="slider-box-link-contact">
                        <img src={emailIcon} alt="" />
                        <h3><FormattedMessage id="Email" defaultMessage="Email" /></h3>
                        <p>{contact && contact.emaili}</p>
                    </a>
                </li>
            </ul>
        );
    }

    return (
        <Fragment>
        <div className="contact-left">
            {contact && contact.pageName ? <h1 className="contact-page-title">{contact.pageName}</h1> : null}
            <div className="block-slideshow-contact__slide-content">
                    <ul className={`slider-boxes-contact slider-boxes-contact--single ${multiple ? 'slider-boxes-contact--stack' : ''}`}>
                        {cards.map((item) => {
                            const selected = multiple && String(selectedId) === String(item.id);
                            return (
                                <li
                                    key={item.id}
                                    className={selected ? 'is-selected' : ''}
                                    {...(multiple ? {
                                        role: 'button',
                                        tabIndex: 0,
                                        onClick: (event) => {
                                            if (event.target.closest('a') || !onSelect) {
                                                return;
                                            }
                                            onSelect(item.id);
                                        },
                                        onKeyDown: (event) => {
                                            if ((event.key === 'Enter' || event.key === ' ') && event.target === event.currentTarget && onSelect) {
                                                event.preventDefault();
                                                onSelect(item.id);
                                            }
                                        },
                                    } : {})}
                                >
                                    <div className="slider-box-link-contact officer-contact-card">
                                        <div className="officer-contact-rows">
                                            {item.name ? (
                                                <div className="officer-contact-row">
                                                    <span className="officer-contact-icon" aria-hidden="true"><i className="fas fa-user" /></span>
                                                    <span>{item.name}</span>
                                                </div>
                                            ) : null}
                                            {item.phone ? (
                                                <div className="officer-contact-row">
                                                    <span className="officer-contact-icon" aria-hidden="true"><i className="fas fa-phone-alt" /></span>
                                                    <a href={`tel:${item.phone}`}>{item.phone}</a>
                                                </div>
                                            ) : null}
                                            {item.email ? (
                                                <div className="officer-contact-row">
                                                    <span className="officer-contact-icon" aria-hidden="true"><i className="fas fa-envelope" /></span>
                                                    <a href={`mailto:${item.email}`}>{item.email}</a>
                                                </div>
                                            ) : null}
                                        </div>
                                        {!multiple && contact.contentHtml ? (
                                            <div className="officer-contact-html typography" dangerouslySetInnerHTML={{ __html: contact.contentHtml }} />
                                        ) : null}
                                        {!multiple && (contact.photos || []).length > 0 && (
                                            <div className="officer-contact-photos">
                                                {contact.photos.map((photo) => (
                                                    <a key={photo.href} href={photo.href} target="_blank" rel="noreferrer">
                                                        <img src={photo.href} alt={photo.name || ''} />
                                                    </a>
                                                ))}
                                            </div>
                                        )}
                                        {!multiple && (contact.documents || []).length > 0 && (
                                            <div className="officer-contact-docs">
                                                {contact.documents.map((document) => (
                                                    <a
                                                        key={document.href}
                                                        className="officer-contact-doc"
                                                        href={document.href}
                                                        download={document.name}
                                                        title={document.name}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <i className="far fa-file-alt" aria-hidden="true" />
                                                        <span>{document.name}</span>
                                                    </a>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                    {multiple && (contact.contentHtml || (contact.photos || []).length || (contact.documents || []).length) ? (
                        <div className="officer-contact-card officer-contact-shared">
                            {contact.contentHtml ? (
                                <div className="officer-contact-html typography" dangerouslySetInnerHTML={{ __html: contact.contentHtml }} />
                            ) : null}
                            {(contact.photos || []).length > 0 && (
                                <div className="officer-contact-photos">
                                    {contact.photos.map((photo) => (
                                        <a key={photo.href} href={photo.href} target="_blank" rel="noreferrer">
                                            <img src={photo.href} alt={photo.name || ''} />
                                        </a>
                                    ))}
                                </div>
                            )}
                            {(contact.documents || []).length > 0 && (
                                <div className="officer-contact-docs">
                                    {contact.documents.map((document) => (
                                        <a
                                            key={document.href}
                                            className="officer-contact-doc"
                                            href={document.href}
                                            download={document.name}
                                            title={document.name}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <i className="far fa-file-alt" aria-hidden="true" />
                                            <span>{document.name}</span>
                                        </a>
                                    ))}
                                </div>
                            )}
                        </div>
                    ) : null}
            </div>
        </div>
        </Fragment>
    );
}

// BlockAplikoPune.propTypes = {
//     // locale: PropTypes.string,
// };

// BlockAplikoPune.defaultProps = {
//     // layout: 'classic',
// };

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BlockContact);
